'use client'
import { useState } from 'react'

export default function NewsletterSection() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  return (
    <section style={{ background: '#0a0c14', padding: '80px 0' }}>
      <div style={{ maxWidth: '520px', margin: '0 auto', padding: '0 32px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#f97316', letterSpacing: '0.06em', marginBottom: '16px' }}>
          JOIN GHASSAN ON HIS JOURNEY
        </h2>
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.52)', lineHeight: 1.95, marginBottom: '36px' }}>
          As We Look Towards The Future, We Invite You To Join Us On This Exciting Journey. Together, We Can Create A Future That Is Bright, Sustainable, And Full Of Opportunity For All
        </p>
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.78)', textAlign: 'left', marginBottom: '8px' }}>Your Email</p>
        <form onSubmit={e => { e.preventDefault(); setSubmitted(true); setEmail(''); setTimeout(() => setSubmitted(false), 3000) }} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <input
            type="email" placeholder="please enter your email" value={email}
            onChange={e => setEmail(e.target.value)} required
            style={{ width: '100%', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', color: 'rgba(255,255,255,0.75)', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', outline: 'none' }}
          />
          <button type="submit" style={{ alignSelf: 'center', padding: '11px 44px', borderRadius: '4px', background: '#f97316', color: '#fff', fontSize: '14px', fontWeight: 700, border: 'none', cursor: 'pointer' }}>
            Submit
          </button>
        </form>
        {submitted && <p style={{ color: '#f97316', fontSize: '13px', marginTop: '12px' }}>Thank you for subscribing!</p>}
      </div>
    </section>
  )
}
